<head>
  <!-- Matomo Tag Manager -->
  <script>
    var _mtm = window._mtm = window._mtm || [];
    _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src='http://10.171.80.34:9603/js/container_akjXKwvF.js'; s.parentNode.insertBefore(g,s);
    </script>
    <!-- End Matomo Tag Manager -->
  </head>
<po-page-default>

    <iframe class="iframe_box" width="1060" height="700" src="https://totvsnews.engpro.totvs.io/esp-news/"></iframe>

</po-page-default>